import { callPromiseSafely } from "../../util/callPromiseSafely";
import type { ViewJobHint } from "../types/TareBridge";
import { getTareBridge } from "./getTareBridge";

/**
 * Get cached view job hint from the native module.
 */
export function getCachedViewJobHint(jobKey: string): Promise<ViewJobHint | null> {
  return callPromiseSafely(() => {
    const bridge = getTareBridge();
    if (!bridge?.getCachedViewJobHint) {
      return Promise.resolve(null);
    }
    return bridge.getCachedViewJobHint(jobKey);
  });
}
